import request from "@/utils/request";
import { ENABLE_API_DBG } from "@/appConfig.js";

function getMbrChannels(params) {
  const qsParams = new URLSearchParams();
  for (let [key, value] of Object.entries(params)) {
    if (!Array.isArray(value)) {
      qsParams.append(key, value);
    } else {
      value.forEach(elem => qsParams.append(key, elem));
    }
  }

  ENABLE_API_DBG &&
    console.log(
      `api.audit.getMbrChannels: params = ${JSON.stringify(
        params
      )}, qsParams = ${qsParams.toString()}`
    );

  return request({
    url: `/audit/channels/?${qsParams.toString()}`,
    method: "get",
    data: params,
  });
}


function getMbrAssets(params) {
  const qsParams = new URLSearchParams();
  for (let [key, value] of Object.entries(params)) {
    if (!Array.isArray(value)) {
      qsParams.append(key, value);
    } else {
      value.forEach(elem => qsParams.append(key, elem));
    }
  }

  ENABLE_API_DBG &&
    console.log(
      `api.audit.getMbrAssets: params = ${JSON.stringify(
        params
      )}, qsParams = ${qsParams.toString()}`
    );

  return request({
    url: `/audit/assets/?${qsParams.toString()}`,
    method: "get",
    data: params,
  });
}

export default {
  getMbrChannels,
  getMbrAssets,
};
